import * as RoutePath from '../Entities/RoutePath'
import * as Preview from 'src/Entities/CommonEntities'

export const typeBodyCompCondition = (type) => {
    switch (type) {
    case Preview.compliancePreview.NAME:
        return true
    case Preview.bodyPreview.NAME:
        return true

    case Preview.transferCompliance.NAME:
        return false

    case Preview.transferBody.NAME:
        return false

    default:
        break
    }
}
export const typePreviewTransferCondition = (type) => {
    switch (type) {
    case Preview.compliancePreview.NAME:
        return false
    case Preview.bodyPreview.NAME:
        return true

    case Preview.transferCompliance.NAME:
        return false

    case Preview.transferBody.NAME:
        return true

    default:
        break
    }
}
export const typeRouting = (type) => {
    switch (type) {
    case Preview.compliancePreview.NAME:
        return RoutePath.COMPLIANCE_PREVIEW.URI
    case Preview.bodyPreview.NAME:
        return RoutePath.BODY_PREVIEW.URI

    case Preview.transferCompliance.NAME:
        return RoutePath.TRANSFER_COMPLIANCE.URI

    case Preview.transferBody.NAME:
        return RoutePath.TRANSFER_BODY.URI

    default:
        break
    }
}
